<table mat-table class="mat-table--wide" [dataSource]="prices">
  <ng-container matColumnDef="price">
    <th mat-header-cell *matHeaderCellDef>PriceModel</th>
    <td mat-cell *matCellDef="let price">
      {{ price.price | currency: price.priceCurrency }}
    </td>
  </ng-container>

  <ng-container matColumnDef="code">
    <th mat-header-cell *matHeaderCellDef>Code</th>
    <td mat-cell *matCellDef="let price">
      {{ price.code }}
    </td>
  </ng-container>

  <ng-container matColumnDef="requirements">
    <th mat-header-cell *matHeaderCellDef>Carriers</th>
    <td mat-cell *matCellDef="let price">
      <div *ngIf="price.feeScheduleId">
        {{ price.feeSchedule?.name || '[Unknown]' }} [Fee Schedule]
      </div>
      <div *ngIf="!price.feeScheduleId && price.requirements.carrierLookups">
        {{
          getCarrierNames(price.requirements.carrierLookups).join(', ')
        }}
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef width="80px">Options</th>
    <td mat-cell *matCellDef="let price" width="80px">
      <div *ngIf="price.feeScheduleId">
        <a
          class="on-hover"
          mat-icon-button
          (click)="openFeeSchedule.emit(price.feeScheduleId)"
        >
          <mat-icon aria-label="Edit Fee Schedule">edit</mat-icon>
        </a>
      </div>
      <div
        *ngIf="!price.feeScheduleId"
        style="width: 80px"
        fxLayout="row"
        fxLayoutAlign="center center"
      >
        <button
          type="button"
          class="on-hover"
          mat-icon-button
          (click)="editProductPrice(price)"
        >
          <mat-icon aria-label="Edit PriceModel">edit</mat-icon>
        </button>

        <button
          type="button"
          class="on-hover"
          mat-icon-button
          color="warn"
          mmxConfirmClick
          [message]="'Are you sure to delete this price?'"
          (confirm)="deleteProductPrice(price)"
        >
          <mat-icon aria-label="Delete PriceModel">delete</mat-icon>
        </button>
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="productsDisplayedColumns"></tr>
  <tr
    mat-row
    *matRowDef="let row; columns: productsDisplayedColumns"
  ></tr>
</table>
